import React from "react";
import classes from "./HeaderHero.module.scss";
import { FormattedMessage } from "react-intl";

const HeaderHero = () => {
  return (
    <div className={["", classes.Container].join(" ")}>
      <div className={["", classes.Element].join(" ")}>
        <div className={classes.Overlay_green}>
          <div className={classes.Content_left}>
            <div className={"jbfs-title-case"}>
              <FormattedMessage
                id={"about.mainbanner.title"}
                defaultMessage={"we provide"}
              />
            </div>
            <div className={"jbfs-title-case"}>
              <FormattedMessage
                id={"about.mainbanner.text"}
                defaultMessage={"the best food as your business solution"}
              />
            </div>
          </div>
        </div>
      </div>
      <div className={["", classes.Element].join(" ")}>
        <div className={classes.Overlay_white}>
          <div className={classes.Content_right}>
            <img
              src={require("../assets/about-icon/icon-animals.png")}
              alt={"gambar"}
            />
            {/* <img
              src={require("../assets/about-icon/icon-cow.png")}
              alt={"gambar"}
            />
            <img
              src={require("../assets/about-icon/icon-dairy.png")}
              alt={"gambar"}
            />
            <img
              src={require("../assets/about-icon/icon-fish.png")}
              alt={"gambar"}
            />
            <img
              src={require("../assets/about-icon/icon-shrimp.png")}
              alt={"gambar"}
            /> */}
            <div className={["jbfs-description"].join(" ")}>
              <p>
                <FormattedMessage
                  id={"about.mainbanner.description.par1"}
                  defaultMessage={
                    "As part of {japfaGroupLink} group, an expert in the food industry for 50 years, Japfa Food was established to be the central sales and marketing support of JAPFA products in Food Service market."
                  }
                  values={{
                    japfaGroupLink: (
                      <b>
                        <a
                          href="https://www.japfacomfeed.co.id"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          JAPFA
                        </a>
                      </b>
                    ),
                    japfaFoodHighlight: (
                      <b>
                        <span className={classes.Span_orange}>
                          Japfa Food (JF)
                        </span>
                      </b>
                    ),
                  }}
                />
              </p>
              <p>
                <FormattedMessage
                  id={"about.mainbanner.description.par2"}
                  defaultMessage={
                    "{jbfsHighlight} provides a variety of animal proteins from primary protein products (chicken, beef, fish, and dairy) to derivative protein products (processed meat, cheese/yoghurt, sauces and seasonings). Stay tuned for more details of our products & services!"
                  }
                  values={{
                    jbfsHighlight: (
                      <b>
                        <span className={classes.Span_orange}>Japfa Food</span>
                      </b>
                    ),
                  }}
                />
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeaderHero;
